package com.anjuros.website.templates.template2.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.ChevronLeftIcon
import com.anjuros.website.components.shared.ChevronRightIcon
import com.anjuros.website.templates.template2.components.Template2ReviewCard
import com.anjuros.website.templates.template2.components.Template2SectionTitle
import com.anjuros.website.templates.template2.modules.Template2Review
import com.anjuros.website.templates.template2.modules.Template2Section
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template2.styles.CompanyColorVar
import com.anjuros.website.templates.template2.styles.ReviewArrowStyle
import com.anjuros.website.templates.template2.styles.ReviewCardMaxWidthStyle
import com.anjuros.website.templates.template2.styles.ReviewSingleCardWidthStyle
import com.anjuros.website.templates.template2.util.ResKey
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb

@Composable
fun Template2ReviewSection(){
    Box(
        modifier = Modifier
            .id(Template2Section.Testimonial.id)
            .fillMaxSize()
            .backgroundImage(
                linearGradient(
                    Template2Theme.Primary.getColor(),
                    rgb(15, 28, 48),
                    LinearGradient.Direction.ToBottom
                )
            )
            .padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        Template2SReviewContent()
    }
}

@Composable
fun Template2SReviewContent() {

    val breakPoint = rememberBreakpoint()
    val color = Template2Theme.Primary.getColor()

    val cardWidth = when {
        breakPoint >= Breakpoint.LG -> 350
        breakPoint >= Breakpoint.MD -> 300
        else -> 250
    }

    val scrollAmount = (cardWidth + 25).toDouble()

    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Template2SectionTitle(
            title = ResKey.TEMPLATE2_REVIEWS_TITLE,
            text = ResKey.TEMPLATE2_REVIEWS_DESC,
            light = true
        )

        Row(
            modifier = Modifier.fillMaxWidth(90.percent),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {

            ChevronLeftIcon(
                modifier = ReviewArrowStyle.toModifier()
                    .setVariable(CompanyColorVar, color)
                    .cursor(Cursor.Pointer)
                    .onClick {

                        document
                            .getElementById("scrollableContainer")
                            ?.scrollBy(
                                x = -scrollAmount,
                                y = 0.0
                            )
                    },
                size = 48
            )


            Row(
                modifier = ReviewCardMaxWidthStyle.toModifier()
                    .id("scrollableContainer")
                    .fillMaxWidth()
                    .gap(25.px)
                    .padding(
                        10.px
                    )
                    .overflow(Overflow.Auto)
                    .scrollBehavior(ScrollBehavior.Smooth)
                    .styleModifier {

                        property(
                            "overflow-x",
                            "auto"
                        )

                        property(
                            "overflow-y",
                            "hidden"
                        )

                        property(
                            "scroll-snap-type",
                            "x mandatory"
                        )

                        property(
                            "scrollbar-width",
                            "none"
                        )
                    },
                // Cards in a row are all as tall as the tallest one.
                verticalAlignment = Alignment.Top
            ) {

                Template2Review.entries.forEach { review ->

                    Template2ReviewCard(
                        modifier = ReviewSingleCardWidthStyle
                            .toModifier()
                            .styleModifier {

                                property(
                                    "scroll-snap-align",
                                    "center"
                                )
                                property("align-self", "stretch")

                            },
                        template2Review = review
                    )
                }
            }


            ChevronRightIcon(
                modifier = ReviewArrowStyle.toModifier()
                    .setVariable(CompanyColorVar, color)
                    .cursor(Cursor.Pointer)
                    .onClick {

                        document
                            .getElementById("scrollableContainer")
                            ?.scrollBy(
                                x = scrollAmount,
                                y = 0.0
                            )
                    },
                size = 48
            )
        }
    }
}